import React, { useContext } from "react";
import { ProduitInterface } from "dataProvider/Produit";
import { IntlContext } from "context";
import _ from "lodash";
import { checkNutriScore } from "../helpers";
import Tooltip from "ui/Form/Element/Tooltip";
import TableRow from "./ConstituantTable/TableRow";

export interface EtiquetageNutritionnelSimplifieProps {
    produit: ProduitInterface | any;
}

const EtiquetageNutritionnelSimplifie: React.FC<EtiquetageNutritionnelSimplifieProps> = ({ produit }) => {
    const intl = useContext(IntlContext);
    const constituantsVE: HashMap<any> = {};

    if (
        !(produit?.produit_etiquetages_simplifies || []).length &&
        checkNutriScore(produit?.etiquetage_simplifie_score_libel) === null
    ) {
        return null;
    }

    const constituantRows = (produit?.produit_etiquetages_simplifies || []).reduce(
        (memo: any, constituant: any, index: number) => {
            const label = constituant?.constituant_libel;
            const value = `${constituant?.valeur_lab} ${constituant?.quantite} ${constituant?.unitemesure_vn_libel}`;
            const label2 = `${(constituant?.uniteexpression_vn_libel || "").toLocaleLowerCase()}`;
            const value2 = constituant?.AR;
            const value3 = constituant?.etiquetage_simplifie_couleur_libel;

            if (_.kebabCase(label).startsWith("valeur-energetique") && constituant?.unitemesure_vn_libel) {
                constituantsVE[constituant?.unitemesure_vn_libel] = constituant;
            } else {
                memo.push(
                    <TableRow
                        key={index}
                        data={[
                            {
                                label,
                                values: [value],
                            },
                            {
                                label: label2,
                                values: [value2],
                            },
                            {
                                label: null,
                                values: [value3],
                            },
                        ]}
                    />
                );
            }

            return memo;
        },
        []
    );

    const constituantRowsVE = (constituantsVE: HashMap<any>) => {
        let label = "";
        let label2 = "";
        let label3: any = null;
        const values: string[] = [];
        let values2: string[] = [];
        const values3: string[] = [];

        let cst = constituantsVE["kj"];
        if (cst) {
            label += ` ${cst?.unitemesure_vn_libel}`;
            values.push(`${cst?.valeur_lab} ${cst?.quantite} ${cst?.unitemesure_vn_libel}`);
            if (cst?.AR) {
                label2 += `${cst?.uniteexpression_vn_libel}`;
                values2.push(`${cst?.AR}`);
            }
            if (cst?.etiquetage_simplifie_couleur_libel) {
                values3.push(`${cst?.etiquetage_simplifie_couleur_libel}`);
            }
        }

        cst = constituantsVE["kcal"];
        if (cst) {
            label += ` (${cst?.unitemesure_vn_libel})`;
            values.push(`${cst?.valeur_lab} ${cst?.quantite} ${cst?.unitemesure_vn_libel}`);
            label2 = !label2 ? cst?.AR : label2;
            if (!label2.length && cst?.AR) {
                label2 += `${cst?.uniteexpression_vn_libel}`;
            }
            if (!values3.length && cst?.etiquetage_simplifie_couleur_libel) {
                values3.push(`${cst?.etiquetage_simplifie_couleur_libel}`);
            }
        }

        if (!label.length) {
            return null;
        }

        return (
            <TableRow
                data={[
                    {
                        label: `${intl.formatMessage("produit.fiche.label.valeur_energetique")} ${label}`,
                        values,
                    },
                    {
                        label: (label2 || "").toLocaleLowerCase(),
                        values: values2,
                    },
                    {
                        label: typeof label3 === "string" ? label3.toLocaleLowerCase() : label3,
                        values: values3,
                    },
                ]}
            />
        );
    };

    return (
        <div className="product-informations__block">
            <div className="information__block-tooltip">
                <h2 className="information__title">
                    {intl.formatMessage("produit.fiche.label.etiquetage_nutritionnel_simplifie")}
                </h2>
                <Tooltip value={intl.formatMessage("produit.fiche.tooltip.etiquetage_nutritionnel_simplifie")} />
            </div>

            {(produit?.produit_etiquetages_simplifies || []).length > 0 && (
                <React.Fragment>
                    <h3 className="information__subtitle">
                        {intl.formatMessage("produit.fiche.label.nutri_couleurs")}
                    </h3>

                    <div className="information-table-group">
                        <table className="table-information-product">
                            <thead className="row-group">
                                <tr className="header-row">
                                    <td className="header-cell">
                                        {intl.formatMessage("produit.fiche.label.constituant")}
                                    </td>
                                    <td className="header-cell">
                                        {intl.formatMessage("produit.fiche.label.quantite")}
                                    </td>
                                    <td className="header-cell">
                                        {intl.formatMessage("produit.fiche.label.unite_expression")}
                                    </td>
                                    <td className="header-cell">
                                        {intl.formatMessage("produit.fiche.label.apport_reference_%")}
                                    </td>
                                    <td className="header-cell">{intl.formatMessage("produit.fiche.label.couleur")}</td>
                                </tr>
                            </thead>
                            <tbody className="row-group">
                                {constituantRowsVE(constituantsVE)}
                                {constituantRows}
                            </tbody>
                        </table>
                    </div>
                </React.Fragment>
            )}

            {/* NUTRI SCORE */}
            {checkNutriScore(produit?.etiquetage_simplifie_score_libel) && (
                <React.Fragment>
                    <h3 className="information__subtitle">{intl.formatMessage("produit.fiche.label.nutri_score")}</h3>
                    <span className="font-bold">
                        {checkNutriScore(produit?.etiquetage_simplifie_score_libel)?.toUpperCase()}
                    </span>
                </React.Fragment>
            )}
        </div>
    );
};

export default EtiquetageNutritionnelSimplifie;
